module.exports = __webpack_public_path__ + "8b3408a16290a91bd01a234e15d93b6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000VLA.png
// module id = 1458
// module chunks = 0